/* ------------------- IMPORTS */
import { Box } from 'components'
import { SpinnerAstersLogo } from './SpinnerAstersLogo'
import React from 'react'

/* ------------------- INTERFACES  */

interface Props {
  cols: number
  data?: JSX.Element[]
  colGap?: number
  rowGap?: number
  width?: number
  height?: number
  marginTop?: number
  marginLeft?: number
  marginRight?: number
  marginBottom?: number
  isLoading?: boolean
  styles?: React.CSSProperties
}

export const GridContainer = ({
  cols,
  data,
  colGap = 24,
  rowGap = 24,
  width,
  height,
  marginTop = 0,
  marginLeft = 0,
  marginRight = 0,
  marginBottom = 0,
  isLoading,
  styles,
}: Props) => {
  return (
    <>
      {isLoading && <SpinnerAstersLogo dimension={100} />}

      {!isLoading && (
        <Box
          style={{
            alignSelf: 'center',
            display: 'grid',
            gridTemplateColumns: `repeat(${cols}, 1fr)`,
            gridColumnGap: `${colGap}px`,
            gridRowGap: `${rowGap}px`,
            width: `${width ? width + 'px' : '100%'}`,
            height: `${height ? height + 'px' : 'auto'}`,
            marginTop: `${marginTop}px`,
            marginLeft: `${marginLeft}px`,
            marginRight: `${marginRight}px`,
            marginBottom: `${marginBottom}px`,
            ...styles,
          }}
        >
          {data}
        </Box>
      )}
    </>
  )
}
